<template>
	<div class="vx-row m-0 p-0">
		<div class="vx-col w-full mb-5">
			<div class="vx-row mb-3">
				<span class="title" :style="titleStyles" v-text="title"></span>
			</div>
			<div class="vx-row">
				<span class="subTitle" :style="subTitleStyles" v-text="subTitle"></span>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: "BreadCrumbs",
	props: {
		title: {
			type: String,
			default: "",
		},
		subTitle: {
			type: String,
			default: "",
		},
		sizeTitle: {
			type: Number,
		},
		lineHeightTitle: {
			type: Number,
		},
		sizeSubTitle: {
			type: Number,
		},
		lineHeightSubTitle: {
			type: Number,
		},
	},
	computed: {
		titleStyles() {
			return {
				"font-size": `${this.sizeTitle}px`,
				"line-height": `${this.lineHeightTitle}px`,
			};
		},
		subTitleStyles() {
			return {
				"font-size": `${this.sizeSubTitle}px`,
				"line-height": `${this.lineHeightSubTitle}px`,
			};
		},
	},
};
</script>
<style lang="scss" scoped>
.title {
	text-transform: capitalize;
	font-style: normal;
	font-weight: bold;
	color: #484848;
}

.subTitle {
	font-style: normal;
	font-weight: 500;
	color: #a3a3a3;
}
</style>
